function Error404() {
    return (
        <>
            <title>{`404 | DireDawn`}</title>
            <p>404 Nothing to see here</p>
        </>
    )
}

export default Error404